export { useSearchResults } from "./use-search-results";
